import { LoaderService } from './../loder_service/loader.service';
import { DataService } from './../../app/data.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
})
export class SupportComponent implements OnInit {
  support_content:any;
  constructor(public restApi:DataService,public toastService:LoaderService) { }

  ngOnInit() {}
ionViewWillEnter(){
 this.toastService.showLoader('')
 this.restApi.get_support_content().subscribe((data:any)=>{
   this.support_content=data.support_content
   this.toastService.hideLoader()
 },(error:any)=>{
  this.toastService.hideLoader()
 })
}
}
